import { OptionModel } from "model/Option.model";
import { BehaviorSubjectBoolean } from "observables/BooleanObservable";
import { BehaviorSubjectOptionModel } from "observables/OptionModelObservable";
import { getInitialOptionList } from "service/shared/others/CompareYearService/getInitialOptionList";
import { setCombinedBehaviorSubject } from "utils/libExtend/setCombinedBehaviorSubject";

export class CompareYearState {
  public readonly value: BehaviorSubjectOptionModel;

  public readonly valid: BehaviorSubjectBoolean;

  public readonly showError: BehaviorSubjectBoolean;

  public readonly optionList: OptionModel[];

  public constructor() {
    this.value = new BehaviorSubjectOptionModel(new OptionModel("", ""));
    this.optionList = getInitialOptionList();

    this.showError = new BehaviorSubjectBoolean(false);
    this.valid = setCombinedBehaviorSubject(this.setValid, this.value);
  }

  private readonly setValid = (value: OptionModel): boolean => {
    return !!value.value;
  };
}
